import React from 'react';
import { Redirect } from 'react-router-dom';
import { OrderLoc } from '../../loc/order';
import { loc } from '../../lib/loc';
import * as Api from '../../lib/api';

import PreloadButton from '../PreloadButton';
import showNotification from '../../utils/showNotification';

export default class OrderSearchForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            load: false,
            orderID: null,
        };
        this.searchRef = React.createRef();
    }

    onSearch(e) {
        e.preventDefault();

        const id = this.searchRef.current.value;
        this.setState({ load: true });

        Api.fetch('order/' + id)
            .then(data => this.setState({ orderID: id }))
            .catch(data => {
                this.setState({ load: false });
                showNotification('danger', data.error_description);
            });
    }

    renderForm() {
        const { load } = this.state;

        return (
            <form className="login-form order-search mb-30" onSubmit={this.onSearch.bind(this)}>
                <input
                    ref={this.searchRef}
                    className="login-form__input order-search__input"
                    placeholder={loc(OrderLoc.searchOrderPlaceholder)}
                    required
                />
                <PreloadButton isLoad={load} className="profile-card__btn custom-btn">
                    {loc(OrderLoc.searchOrderButton)}
                </PreloadButton>
            </form>
        );
    }

    render() {
        const { orderID } = this.state;
        return orderID == null ? this.renderForm() : <Redirect to={'/orders/' + orderID + '/'} />;
    }
}
